var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fh flex-center auth-screen-wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo-text.png"),"alt":"Logo"}}),_c('section',{staticClass:"sign-in-contents"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }